module.exports = __webpack_public_path__ + "img/1f9a3.aa81df2.svg";